import React from 'react';

function ResourcesPage() {
  return (
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold text-gray-900 mb-8">Resources</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {/* Documentation Section */}
        <div className="bg-white rounded-lg shadow-md p-6">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Documentation</h2>
          <p className="text-gray-600 mb-4">
            Comprehensive guides and API references to help you get the most out of our platform.
          </p>
          <a href="#docs" className="text-blue-600 hover:text-blue-800 font-medium">
            Browse Documentation →
          </a>
        </div>

        {/* Blog Section */}
        <div className="bg-white rounded-lg shadow-md p-6">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Blog</h2>
          <p className="text-gray-600 mb-4">
            Stay up to date with the latest industry insights, tips, and best practices.
          </p>
          <a href="#blog" className="text-blue-600 hover:text-blue-800 font-medium">
            Read Our Blog →
          </a>
        </div>

        {/* Case Studies Section */}
        <div className="bg-white rounded-lg shadow-md p-6">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Case Studies</h2>
          <p className="text-gray-600 mb-4">
            Real-world examples of how customers are succeeding with our solutions.
          </p>
          <a href="#case-studies" className="text-blue-600 hover:text-blue-800 font-medium">
            View Case Studies →
          </a>
        </div>

        {/* Webinars Section */}
        <div className="bg-white rounded-lg shadow-md p-6">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Webinars</h2>
          <p className="text-gray-600 mb-4">
            Join our live sessions and learn from industry experts and product specialists.
          </p>
          <a href="#webinars" className="text-blue-600 hover:text-blue-800 font-medium">
            Watch Webinars →
          </a>
        </div>

        {/* Help Center Section */}
        <div className="bg-white rounded-lg shadow-md p-6">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Help Center</h2>
          <p className="text-gray-600 mb-4">
            Find answers to common questions and get support when you need it.
          </p>
          <a href="#help" className="text-blue-600 hover:text-blue-800 font-medium">
            Visit Help Center →
          </a>
        </div>

        {/* Community Section */}
        <div className="bg-white rounded-lg shadow-md p-6">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Community</h2>
          <p className="text-gray-600 mb-4">
            Connect with other users, share experiences, and get involved in discussions.
          </p>
          <a href="#community" className="text-blue-600 hover:text-blue-800 font-medium">
            Join Community →
          </a>
        </div>
      </div>
    </div>
  );
}

export default ResourcesPage;